export default __webpack_public_path__ + "static/media/boy6.94e73b22.jpg";